import React from "react";

import { Link } from "react-router-dom";

export function LearnMoreBtn({ link = "/get-a-demo" }) {
  return (
    <Link to={link}>
      <button className="learnMoreBtn">
        Learn More
        <span className="arrow">&rarr;</span>
      </button>
    </Link>
  );
}
